import { Link } from "react-router-dom";

// Documento legal con índice. Cada sección es { id, title, body } y se numera sola.
// En el celu el índice va arriba; en la compu queda fijo al costado.
const LegalDoc = ({ updated, sections, related }) => {
  return (
    <section className="lp-section lp-legal-section">
        <div className="lp-container lp-legal">
            <nav className="lp-legal-toc" aria-label="Índice">
                <span className="lp-legal-toc-title">En esta página</span>
                <ol>
                    {
                        sections.map(section => (
                            <li key={section.id}><a href={"#" + section.id}>{section.title}</a></li>
                        ))
                    }
                </ol>
                {related && <Link to={related.to} className="lp-text-link">{related.label}</Link>}
            </nav>

            <article className="lp-legal-doc">
                <p className="lp-legal-updated">Última actualización: {updated}</p>
                {
                    sections.map((section, i) => (
                        <section key={section.id} id={section.id} className="lp-legal-block">
                            <h2>
                                <span className="lp-legal-num" aria-hidden="true">{i + 1}</span>
                                {section.title}
                            </h2>
                            {section.body}
                        </section>
                    ))
                }
                <div className="lp-legal-contact">
                    <strong>¿Tenés alguna duda?</strong>
                    <p>Escribinos a <a href="mailto:contacto@miqrapp.com">contacto@miqrapp.com</a> y te respondemos.</p>
                </div>
            </article>
        </div>
    </section>
  )
}

export default LegalDoc
